<div class="coin-row-container">
  <div class="coin-row">
    <div class="coin-name">
      <img [src]="coin.logo" alt="">
      {{coin.baseCurrency}} {{coin.code}}
    </div>
    <div class="coin-price">{{coin.current_price_usd}}</div>
  </div>
</div>
